import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "txt",
  "use": "txt-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol viewBox=\"0 0 83.3 102.9\" id=\"txt\"><path fill=\"#26b1b9\" d=\"M54.4 29.6V13.2H15.6v75.1h52V29.6z\" /><path fill=\"#59c7d6\" d=\"M67.6 29.6L54.4 13.2v16.4z\" /><path fill=\"none\" d=\"M27.6 44.5h28.1v16.2H27.6z\" /><text transform=\"translate(27.61 55.78)\" font-size=\"15\" font-family=\"Roboto\" fill=\"#fff\">TXT</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/txt.svg
// module id = YRnR
// module chunks = 1